// extracted by mini-css-extract-plugin
export default {"mainContainer":"announcement_mainContainer__hEfnR"};